// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../../shared/src/Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Plaid = require("../../../shared/src/bindings/Plaid.bs.js");
var Apollo = require("../../../shared/src/bindings/Apollo.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var StripeTypes_Token = require("../../../shared/src/bindings/StripeTypes_Token.bs.js");
var CommonTypes_Business_Id = require("../../../shared/src/types/business/CommonTypes_Business_Id.bs.js");

var Raw = {};

var query = "mutation ($accountId: String!, $businessId: BigInt!, $publicToken: String!)  {\nlinkPlaidBusinessAccount(input: {accountId: $accountId, businessId: $businessId, publicToken: $publicToken})  {\nsuccess  \n}\n\n}\n";

function parse(value) {
  var value$1 = value.linkPlaidBusinessAccount;
  return {
          linkPlaidBusinessAccount: !(value$1 == null) ? ({
                success: value$1.success
              }) : undefined
        };
}

function serialize(value) {
  var value$1 = value.linkPlaidBusinessAccount;
  var linkPlaidBusinessAccount;
  if (value$1 !== undefined) {
    var value$2 = value$1.success;
    linkPlaidBusinessAccount = {
      success: value$2
    };
  } else {
    linkPlaidBusinessAccount = null;
  }
  return {
          linkPlaidBusinessAccount: linkPlaidBusinessAccount
        };
}

function serializeVariables(inp) {
  return {
          accountId: inp.accountId,
          businessId: inp.businessId,
          publicToken: inp.publicToken
        };
}

function makeVariables(accountId, businessId, publicToken, param) {
  return {
          accountId: accountId,
          businessId: businessId,
          publicToken: publicToken
        };
}

function variables(param) {
  return Json.Encode.object_({
              hd: [
                "accountId",
                Curry._1(Plaid.AccountId.encode, param.accountId)
              ],
              tl: {
                hd: [
                  "businessId",
                  Curry._1(CommonTypes_Business_Id.encode, param.businessId)
                ],
                tl: {
                  hd: [
                    "publicToken",
                    Curry._1(Plaid.PublicToken.encode, param.publicToken)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function decode(param) {
  return Relude_Option.pure(undefined);
}

var Definition = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  variables: variables,
  decode: decode
};

var include = Apollo.CreateMutation({
      Raw: Raw,
      query: query,
      variables: variables,
      parse: parse,
      decode: decode
    });

var ConnectPlaid_graphqlMutationAST = include.graphqlMutationAST;

var ConnectPlaid_mutate = include.mutate;

var ConnectPlaid_mutateStoreError = include.mutateStoreError;

var ConnectPlaid_mutateResult = include.mutateResult;

var ConnectPlaid_mutateResultStore = include.mutateResultStore;

var ConnectPlaid_mutateAsyncData = include.mutateAsyncData;

var ConnectPlaid_mutateAsyncResult = include.mutateAsyncResult;

var ConnectPlaid_mutateAsycResultApolloError = include.mutateAsycResultApolloError;

var ConnectPlaid = {
  Definition: Definition,
  graphqlMutationAST: ConnectPlaid_graphqlMutationAST,
  mutate: ConnectPlaid_mutate,
  mutateStoreError: ConnectPlaid_mutateStoreError,
  mutateResult: ConnectPlaid_mutateResult,
  mutateResultStore: ConnectPlaid_mutateResultStore,
  mutateAsyncData: ConnectPlaid_mutateAsyncData,
  mutateAsyncResult: ConnectPlaid_mutateAsyncResult,
  mutateAsycResultApolloError: ConnectPlaid_mutateAsycResultApolloError
};

var Raw$1 = {};

var query$1 = "mutation ($businessId: BigInt!, $token: String!)  {\nbusinessUpdateStripeCard(input: {businessId: $businessId, token: $token})  {\nsuccess  \n}\n\n}\n";

function parse$1(value) {
  var value$1 = value.businessUpdateStripeCard;
  return {
          businessUpdateStripeCard: !(value$1 == null) ? ({
                success: value$1.success
              }) : undefined
        };
}

function serialize$1(value) {
  var value$1 = value.businessUpdateStripeCard;
  var businessUpdateStripeCard;
  if (value$1 !== undefined) {
    var value$2 = value$1.success;
    businessUpdateStripeCard = {
      success: value$2
    };
  } else {
    businessUpdateStripeCard = null;
  }
  return {
          businessUpdateStripeCard: businessUpdateStripeCard
        };
}

function serializeVariables$1(inp) {
  return {
          businessId: inp.businessId,
          token: inp.token
        };
}

function makeVariables$1(businessId, token, param) {
  return {
          businessId: businessId,
          token: token
        };
}

function variables$1(param) {
  return Json.Encode.object_({
              hd: [
                "businessId",
                Curry._1(CommonTypes_Business_Id.encode, param.businessId)
              ],
              tl: {
                hd: [
                  "token",
                  Curry._1(StripeTypes_Token.Id.encode, param.tokenId)
                ],
                tl: /* [] */0
              }
            });
}

function decode$1(param) {
  return Relude_Option.pure(undefined);
}

var Definition$1 = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  variables: variables$1,
  decode: decode$1
};

var include$1 = Apollo.CreateMutation({
      Raw: Raw$1,
      query: query$1,
      variables: variables$1,
      parse: parse$1,
      decode: decode$1
    });

var ConnectStripe_graphqlMutationAST = include$1.graphqlMutationAST;

var ConnectStripe_mutate = include$1.mutate;

var ConnectStripe_mutateStoreError = include$1.mutateStoreError;

var ConnectStripe_mutateResult = include$1.mutateResult;

var ConnectStripe_mutateResultStore = include$1.mutateResultStore;

var ConnectStripe_mutateAsyncData = include$1.mutateAsyncData;

var ConnectStripe_mutateAsyncResult = include$1.mutateAsyncResult;

var ConnectStripe_mutateAsycResultApolloError = include$1.mutateAsycResultApolloError;

var ConnectStripe = {
  Definition: Definition$1,
  graphqlMutationAST: ConnectStripe_graphqlMutationAST,
  mutate: ConnectStripe_mutate,
  mutateStoreError: ConnectStripe_mutateStoreError,
  mutateResult: ConnectStripe_mutateResult,
  mutateResultStore: ConnectStripe_mutateResultStore,
  mutateAsyncData: ConnectStripe_mutateAsyncData,
  mutateAsyncResult: ConnectStripe_mutateAsyncResult,
  mutateAsycResultApolloError: ConnectStripe_mutateAsycResultApolloError
};

exports.ConnectPlaid = ConnectPlaid;
exports.ConnectStripe = ConnectStripe;
/* include Not a pure module */
